import {useCallback, useEffect, useRef} from 'react';
import {TalkShape} from '../TalkShape/TalkShape';
import {WebpImageWithApngFallback} from '../WebpImageWithApngFallback/WebpImageWithApngFallback';
import {WebpImageElement} from '../WebpImageWithApngFallback/WepImageElement.interface';
import {TalkEmoticonProps} from './TalkEmoticonProps.interface';

export function TalkEmoticon({
  isIos,
  isShowingTalk,
  emoticonWebpUrl,
  emoticonApngUrl,
  talkColor,
  talkShapeType,
  characterName,
  characterNameColor,
  talkPosition,
}: TalkEmoticonProps) {
  const emoticonRef = useRef<WebpImageElement>(null);
  const resetAnimation = useCallback(() => {
    emoticonRef.current?.replay();
  }, []);

  // 톡이 다시 보여질 때는 animation reset
  useEffect(() => {
    if (!isShowingTalk) {
      return;
    }
    resetAnimation();
  }, [isShowingTalk, resetAnimation]);

  return (
    <TalkShape
      talkShapeType={talkShapeType}
      characterName={characterName}
      characterNameColor={characterNameColor}
      talkPosition={talkPosition}
      talkColor={talkColor}
    >
      <WebpImageWithApngFallback
        imageUrl={emoticonWebpUrl}
        apngUrl={emoticonApngUrl}
        ref={emoticonRef}
        alt="이모티콘"
        onClick={resetAnimation}
        isIos={isIos}
        className="box-border h-360tvs w-360tvs"
        isWebp
      />
    </TalkShape>
  );
}
